import { connect } from "react-redux";

import KompressorWartungChart from "./KompressorWartungChart";

import { makeUndefinedCompressor } from "../model/Kompressor";

export default connect((state, own_props) => ({
	data: state.ablauf.maintenance,
	compressor: state.ablauf.compressors[own_props.match.params.compressorIndex] ||
		makeUndefinedCompressor(own_props.match.params.compressorIndex)
}))(KompressorWartungChart);
